import { render, staticRenderFns } from "./Cpzx.vue?vue&type=template&id=19a7f121&scoped=true"
import script from "./Cpzx.vue?vue&type=script&lang=js"
export * from "./Cpzx.vue?vue&type=script&lang=js"
import style0 from "./Cpzx.vue?vue&type=style&index=0&id=19a7f121&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7f121",
  null
  
)

export default component.exports